import { buildSelector } from '@/shared/lib/store';

// Selector for getting the unread notification count
export const [useUnreadNotificationCount, getUnreadNotificationCount] =
    buildSelector((state) => state.notification?.unreadCount ?? 0);
